module.exports = __webpack_public_path__ + "static/images/head1.e45d609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head/head1.jpg
// module id = G4DH
// module chunks = 1